<script>
import MethodButtonBase from './MethodButtonBase';
import IconSpid from '../../assets/svg/spid-logo.svg';
export default {
  name: 'SpidButton',
  components: {
    MethodButtonBase,
    IconSpid,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconSpid :class="$style.icon" />
    </template>
  </MethodButtonBase>
</template>


<style lang="scss" module>
.icon {
  display: block;
  width: 63px;
  height: auto;
}
</style>
